// @flow
import LogRocket from 'logrocket'

// Utils
import { requestSanitizer, responseSanitizer } from './utils'

function identifyLogRocketUser(user: ?Object) {
  if (!user || !user.id) {
    return
  }

  LogRocket.identify(String(user.id), {
    username: user.username || 'Unknown',
    email: user.email || 'Unknown',
    name: [user.first, user.last].filter(Boolean).join(' ') || 'Unknown',
    roles: Array.isArray(user.roles) && user.roles.length ? user.roles.join(', ') : 'Unknown',
  })
}

export function initializeLogRocket(user: ?Object) {
  if (process.env.LOGROCKET_APP_ID) {
    console.info('Initializing LogRocket')

    LogRocket.init(process.env.LOGROCKET_APP_ID, {
      network: {
        requestSanitizer,
        responseSanitizer,
      },
    })

    identifyLogRocketUser(user)
  }
}
